import {ReactNode} from "react";
import {useInstallBehavior} from "./useInstallBehavior.ts";
import {Context} from "./installerContext.tsx";

export function InstallerProvider({children}: { children: ReactNode }) {
	const params = useInstallBehavior();
	return <Context.Provider value={params}>{children}</Context.Provider>;
}
